// The sign tools (aldoo-ra/PDFViewer/SignTools) in a dialog of their own, room
// for them on any screen: a dialog on a computer, the whole screen on a phone.
// Shared by the vendor's contract (ContractCard) and the admin's own signature
// for Aldoo's contracts (ContractSignees); "sign with your phone" goes through
// aldoo-na's sign sessions (store/sign-sessions) by `purpose` / `ref`.
import React from "react"
import QRCode from "react-qr-code"
import config from "aldoo-ra/Config"
import SignTools, { useWide } from "aldoo-ra/PDFViewer/SignTools"
import Modal from "aldoo-ra/Modal"
import { SignSessionCreate, SignSessionGet } from "../AdminShared/api"
import { langFromPath } from "../Storefront/utils/contentRoutes"

// the name the backend gives an account that has none of its own
const PLACEHOLDER_NAMES = ["aldoo user"]

/** The account's own name, to start the signer's name with ("" for the placeholder). */
export function accountName(auth) {
  const name = String(auth?.name || "").trim()
  return PLACEHOLDER_NAMES.includes(name.toLowerCase()) ? "" : name
}

/** Where the phone opens: this site (on localhost, the computer's address on the network), in the page's language. */
function phoneUrl(token) {
  const { protocol, hostname, port, origin, pathname } = window.location
  const local = hostname === "localhost" || hostname === "127.0.0.1"
  const base = local && config.LOCAL_NETWORK_ADDRESS ? `${protocol}//${config.LOCAL_NETWORK_ADDRESS}${port ? `:${port}` : ""}` : origin
  const lang = langFromPath(pathname)
  return `${base}${lang ? `/${lang}` : ""}/sign-on-phone?session=${encodeURIComponent(token)}`
}

/** "Sign with your phone": its sessions on aldoo-na (store/sign-sessions), the QR code drawn here. */
export const phoneSigning = (purpose, ref) => ({
  createSession: () => SignSessionCreate(purpose, ref),
  getSession: (token) => SignSessionGet(token),
  urlOf: phoneUrl,
  renderQR: (url) => <QRCode value={url} size={168} level="M" />
})

/** The dialog; what SignTools takes (onSign, busy, error, defaultName, consentText, texts, mobile) is passed through. */
export default function SignDialog({ open, onClose, title, busy = false, texts, "data-testid": testId, ...tools }) {
  const wide = useWide()
  return (
    <Modal
      isOpen={open}
      onClose={() => !busy && onClose?.()}
      title={title}
      variant={wide ? "admin_compact" : "admin_fullscreen"}
      closeOnEscape={!busy}
      styleOverrides={
        wide
          ? { container: "bg-admin_paper w-full max-w-[560px] max-h-[90vh] overflow-y-auto md:rounded-md border border-admin_bordered shadow-lg p-0 m-0", header: "relative flex justify-between items-center px-5 pt-5 pb-1" }
          : { header: "relative flex justify-between items-center px-4 py-3 shrink-0", contentWrapper: "flex-1 min-h-0 overflow-y-auto", content: "px-4 pb-6" }
      }
    >
      <div className={wide ? "px-5 pb-2" : ""}>
        <SignTools {...tools} busy={busy} texts={{ ...texts, title: "" }} className="border-0 p-0 shadow-none" data-testid={testId} />
      </div>
    </Modal>
  )
}
